import { render, staticRenderFns } from "./news-list.vue?vue&type=template&id=46fa3470&scoped=true&"
import script from "./news-list.vue?vue&type=script&lang=js&"
export * from "./news-list.vue?vue&type=script&lang=js&"
import style0 from "./news-list.vue?vue&type=style&index=0&id=46fa3470&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fa3470",
  null
  
)

export default component.exports